<template>
  <main class="sign-in-page min-h-screen bg-brand-navy px-6 text-center text-white">
    <div class="mx-auto flex min-h-screen w-full max-w-sm flex-col items-center justify-center">
      <img src="/wordmark.png" alt="Five Picks" class="mb-7 h-20 w-auto" />

      <h1 class="max-w-xs text-2xl font-extrabold leading-tight tracking-tight">
        Five picks. Because one bad decision wasn’t enough.
      </h1>

      <div class="mt-7 w-full">
        <div ref="buttonEl" class="flex min-h-[44px] justify-center"></div>

        <p v-if="!scriptLoaded && clientIdConfigured" class="mt-3 text-xs text-slate-500">
          Loading sign-in…
        </p>
        <p v-if="!clientIdConfigured" class="mt-3 text-xs text-amber-400">
          Google sign-in is not configured yet.
        </p>
        <p
          v-if="error"
          class="mt-3 rounded-xl border border-rose-500/20 bg-rose-500/10 px-3 py-2 text-xs text-rose-300"
        >
          {{ error }}
        </p>

        <button
          v-if="isDev"
          type="button"
          class="mt-4 w-full rounded-full border border-white/15 px-4 py-2 text-xs text-slate-300 hover:bg-white/5"
          @click="handleDev"
        >
          Continue without Google (dev)
        </button>
      </div>

      <p class="mt-8 text-xs text-slate-500">
        Last year’s picks were wrong. This year’s have charts.
      </p>
    </div>
  </main>
</template>

<script>
import auth from "@/utils/auth";

export default {
  name: "SignIn",
  data() {
    return {
      scriptLoaded: false,
      error: null,
    };
  },
  computed: {
    clientIdConfigured() {
      return Boolean(process.env.VUE_APP_GOOGLE_CLIENT_ID);
    },
    isDev() {
      return process.env.NODE_ENV !== "production";
    },
  },
  mounted() {
    if (this.clientIdConfigured) this.waitForGoogle();
  },
  methods: {
    // The GIS script tag is async, so it may not have run yet by the time
    // this component mounts -- poll briefly rather than assuming a load
    // order between an external script and Vue's own mount timing.
    waitForGoogle(attempt = 0) {
      if (window.google?.accounts?.id) {
        this.scriptLoaded = true;
        this.renderButton();
        return;
      }
      if (attempt > 50) {
        this.error = "Could not reach Google's sign-in script.";
        return;
      }
      setTimeout(() => this.waitForGoogle(attempt + 1), 100);
    },
    renderButton() {
      window.google.accounts.id.initialize({
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        callback: this.handleCredential,
      });
      window.google.accounts.id.renderButton(this.$refs.buttonEl, {
        theme: "filled_black",
        size: "large",
        shape: "pill",
        text: "signin_with",
        width: Math.min(window.innerWidth - 48, 384),
      });
    },
    async handleCredential(response) {
      this.error = null;
      try {
        await auth.signInWithGoogle(response.credential);
      } catch (e) {
        this.error = e.response?.data?.error || "Sign-in failed. Please try again.";
      }
    },
    async handleDev() {
      this.error = null;
      try {
        await auth.signInDev();
      } catch (e) {
        this.error = e.response?.data?.error || "Dev sign-in failed.";
      }
    },
  },
};
</script>

<style scoped>
.sign-in-page {
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
}
</style>
